export * from '@fhs/routing/src/routes/v2/signin/(continuewithemail)';
export { default } from '@fhs/routing/src/routes/v2/signin/(continuewithemail)';
